import React, { useEffect, useState } from 'react';
import QuickStatsTableContainer from './QuickStatsTableContainer';
import classes from '../index.module.scss';
import { quickStatsGet } from '../../../api';
import Loading from '../../Loading';

const QUICK_STATS_HEADER_LIST = [
  'Type',
  'Today',
  'This Month',
  'This Year',
  'Total'
];

const QuickStats = () => {
  const [statsList, setStatsList] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    quickStatsGet()
      .then(response => {
        setStatsList(response.data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      })
  }, []);

  return (
    <>
      <div className={`${classes.Custom_Min_Height} mb-5`}>
        <h5>Custom Stats</h5>
      </div>
      <QuickStatsTableContainer 
        stats={statsList} 
        header_list={QUICK_STATS_HEADER_LIST} 
      />
      {loading && <Loading />}
    </>
  )
}

export default QuickStats;